import React from 'react';
import RuleTooltip from './RuleTooltip';
import { getCategoryLabel } from '../../data/analyzerRules';

const AnalyzerIssueDetail = ({ issue, onClose, onPrev, onNext, hasPrev, hasNext }) => {
  if (!issue) return null;

  return (
    <div
      className="fixed inset-0 z-30 flex justify-end bg-black/20"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="h-full w-full max-w-md shadow-2xl p-6 overflow-y-auto"
        style={{background:'var(--tqa-surface)',borderLeft:'1px solid var(--tqa-border-dark)'}}
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="text-xs uppercase tracking-wide" style={{color:'rgba(255,255,255,0.4)'}}>Issue detail</div>
            <div className="text-lg font-semibold" style={{color:'rgba(255,255,255,0.9)'}}>{issue.errorSeverity || 'Info'}</div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="transition-colors" style={{color:'rgba(255,255,255,0.4)'}} onMouseEnter={e=>e.currentTarget.style.color='rgba(255,255,255,0.8)'} onMouseLeave={e=>e.currentTarget.style.color='rgba(255,255,255,0.4)'}
            aria-label="Close"
          >
            X
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <div className="text-xs uppercase tracking-wide" style={{color:'rgba(255,255,255,0.4)'}}>Error code</div>
            <RuleTooltip issue={issue}>
              <div className="mt-1 inline-flex items-center gap-2 rounded-md px-2 py-1 text-sm font-mono" style={{border:'1px solid var(--tqa-border-dark)',color:'rgba(255,255,255,0.8)'}}>
                {issue.errorCode || 'Unknown'}
              </div>
            </RuleTooltip>
            <div className="text-xs mt-1" style={{color:'rgba(255,255,255,0.45)'}}>{getCategoryLabel(issue.errorCode)}</div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wide" style={{color:'rgba(255,255,255,0.4)'}}>File</div>
            <div className="text-sm mt-1" style={{color:'rgba(255,255,255,0.75)'}}>{issue.filePath || 'Unknown file'}</div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wide" style={{color:'rgba(255,255,255,0.4)'}}>Affected item</div>
            <div className="text-sm mt-1" style={{color:'rgba(255,255,255,0.75)'}}>{issue.item || 'Not specified'}</div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wide" style={{color:'rgba(255,255,255,0.4)'}}>Description</div>
            <div className="text-sm mt-1" style={{color:'rgba(255,255,255,0.75)'}}>{issue.description || 'No description available.'}</div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wide" style={{color:'rgba(255,255,255,0.4)'}}>Recommendation</div>
            <div className="text-sm mt-1" style={{color:'rgba(255,255,255,0.75)'}}>{issue.recommendation || 'No recommendation available.'}</div>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-between">
          <button
            type="button"
            onClick={onPrev}
            disabled={!hasPrev}
            className="px-3 py-1.5 rounded-md text-sm disabled:opacity-40" style={{border:'1px solid var(--tqa-border-dark)',color:'rgba(255,255,255,0.65)'}}
          >
            Prev
          </button>
          <button
            type="button"
            onClick={onNext}
            disabled={!hasNext}
            className="px-3 py-1.5 rounded-md text-sm disabled:opacity-40" style={{border:'1px solid var(--tqa-border-dark)',color:'rgba(255,255,255,0.65)'}}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyzerIssueDetail;
